import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { listMyTicketsQueryKey } from '@mopla/ticketshop-api';

/**
 * Returns a callback that invalidates the purchased-tickets query, forcing the
 * ticketshop section to refetch from BE. Used by the Tickets page
 * pull-to-refresh so the Ticketshop stays in sync alongside the RxDB bookings
 * resync. Resolves once the refetch completes, so callers can await it (e.g. to
 * keep a refresh spinner visible).
 */
export const useRefreshMyTickets = (): (() => Promise<void>) => {
	const queryClient = useQueryClient();

	return useCallback(
		() => queryClient.invalidateQueries({ queryKey: listMyTicketsQueryKey() }),
		[queryClient]
	);
};
